import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/auth/AuthContext';
import { LayoutProvider } from './hooks/layout/LayoutContext';
import { ApolloProvider } from '@apollo/client';
import { CookiesProvider } from 'react-cookie';
import { client } from './apollo-clients';
import ErrorBoundary from './shared/components/error-boundary/ErrorBoundary';

// Suppress ResizeObserver loop warnings in development
if (process.env.NODE_ENV === 'development') {
  // Override console.error for ResizeObserver warnings
  const originalError = console.error;
  console.error = (...args) => {
    if (
      args[0] &&
      args[0].toString().includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  // Handle unhandled errors and rejections globally
  const handleError = (event: ErrorEvent) => {
    if (
      event.message &&
      event.message.includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  };

  const handleRejection = (event: PromiseRejectionEvent) => {
    if (
      event.reason &&
      event.reason.toString().includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      event.preventDefault();
      return false;
    }
  };

  window.addEventListener('error', handleError, true);
  window.addEventListener('unhandledrejection', handleRejection, true);

  // Override the ResizeObserver constructor to catch errors at the source
  const originalResizeObserver = window.ResizeObserver;
  if (originalResizeObserver) {
    window.ResizeObserver = class extends originalResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        const wrappedCallback: ResizeObserverCallback = (entries, observer) => {
          try {
            callback(entries, observer);
          } catch (error: any) {
            if (
              error.message &&
              error.message.includes('ResizeObserver loop completed with undelivered notifications')
            ) {
              // Silently ignore this specific error
              return;
            }
            throw error;
          }
        };
        super(wrappedCallback);
      }
    };
  }
}

ReactDOM.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <CookiesProvider>
      <LayoutProvider>
        <ApolloProvider client={client}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ApolloProvider>
      </LayoutProvider>
    </CookiesProvider>
  </ErrorBoundary>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
